<template>
  <div class="container">
    <hero-caroucel>
      <hero-caroucel-item
        :dimmed="false"
        bg-image="/images/heum-people/이재희세무사님-v3.jpg"
        text-color="1e1e1e"
      >
        <template v-slot:subtitle>이재희 대표 세무사</template>
        <template v-slot:title>
          고객과 함께 성장하는<br />
          혜움을 만듭니다.
        </template>
        <template v-slot:button>
          <nuxt-link
            to="/heum-people/고객과 함께 성장하는 혜움을 만듭니다."
            class="btn btn--black"
          >
            자세히 보기
          </nuxt-link>
        </template>
      </hero-caroucel-item>
    </hero-caroucel>

    <content-section bg-color="#fafafa">
      <interview />
    </content-section>

    <content-section>
      <heum-work />
    </content-section>

    <content-section bg-color="#fafafa">
      <div class="heum-employees">
        <div class="heum-employees__title">혜움을 만드는 사람들</div>
        <div class="heum-employees__list">
          <div class="grid">
            <div
              v-for="(employee, index) in employees"
              :key="index"
              class="grid__cell col-1/2 col-1/3--handheld-and-up col-1/4--lap-and-up"
            >
              <div class="heum-employees__item">
                <div class="heum-employees__photo">
                  <img :src="employee.fields.photo.fields.file.url" alt="" />
                </div>
                <div class="heum-employees__name">
                  {{ employee.fields.name }}
                </div>
                <div class="heum-employees__position">
                  {{ employee.fields.position }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </content-section>
    <heum-join title="혜움 서비스의 가장 큰 경쟁력은 사람입니다." />
  </div>
</template>

<script>
import HeroCaroucel from '~/components/hero-caroucel'
import HeroCaroucelItem from '~/components/hero-caroucel-item'

import ContentSection from '~/components/common/content-section'
import HeumJoin from '~/components/heum-join'

import Interview from '~/components/heum-people/interview'
import HeumWork from '~/components/heum-people/heum-work'

import { createClient } from '~/plugins/contentful'
const contentfulClient = createClient()

export default {
  layout: 'invert-font-header',
  head: {
    title: '혜움 피플 - 세무법인혜움'
  },
  components: {
    HeroCaroucel,
    HeroCaroucelItem,
    ContentSection,
    Interview,
    HeumWork,
    HeumJoin
  },
  asyncData({ env }) {
    return Promise.all([
      contentfulClient.getEntries({
        content_type: 'heumPeople',
        order: 'fields.weight'
      })
    ]).then(([employees]) => {
      return {
        employees: employees.items
      }
    })
  }
}
</script>

<style lang="scss">
.heum-employees {
  padding: 3rem 1rem;

  @include av-mq(lap-and-up) {
    padding: 5.5rem 1rem;
  }

  &__title {
    margin-bottom: 3rem;
    font-size: 26px;
    line-height: 1.48;
    text-align: center;
    color: #323438;

    @include av-mq(lap-and-up) {
      margin-bottom: 5rem;
      font-size: 32px;
    }
  }

  &__item {
    margin-bottom: 2rem;

    &:hover {
      .heum-employees__photo img {
        transform: scale(1.1);
      }
    }
  }

  &__list {
    max-width: 800px;
    margin: 0 auto;
  }

  &__photo {
    margin-bottom: 1rem;
    overflow: hidden;
    border-radius: 5px;

    img {
      max-width: 100%;
      transition: transform 0.5s;
    }
  }

  &__name {
    margin-bottom: 0.5rem;
    font-size: 20px;
    color: #323438;
  }

  &__position {
    padding-left: 1px;
    font-size: 16px;
    color: #85878c;
  }
}
</style>
